var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.6b2af7c3f19b28e2a2dfb5c7f435c14a.svg#Z';
                    var viewUrl = 'sprites.6b2af7c3f19b28e2a2dfb5c7f435c14a.svg#view-Z';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 20 20',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };